export { default } from './BannerOffer'
